const NOVA_COMPATIBILITY_BASE_PATH = '/chat';

type NovaMountBasePath = '' | typeof NOVA_COMPATIBILITY_BASE_PATH;

function getPathname(path: string): string {
  return path.split(/[?#]/, 1)[0] || '/';
}

export function getNovaMountBasePath(path?: string): NovaMountBasePath {
  const currentPath = path ?? (typeof window === 'undefined' ? '/' : window.location.pathname);
  const pathname = getPathname(currentPath);

  if (pathname === NOVA_COMPATIBILITY_BASE_PATH || pathname.startsWith(`${NOVA_COMPATIBILITY_BASE_PATH}/`)) {
    return NOVA_COMPATIBILITY_BASE_PATH;
  }

  return '';
}

export function getNovaMountedPath(path: string, currentPath?: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${getNovaMountBasePath(currentPath)}${normalizedPath}`;
}
